var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { CONFIG } from "../../../config/app.config";
import { EProduct } from "../../../config/app.config.types";
import logger from "../../../logger";
import { getMappedName, getName } from "../../../redux/contact/contact.utils";
import { formatAddress as formatAddressLead } from "../../../reduxInsurance/lead/lead.utils";
import { mapActivitySubtypeToString, mapActivityTypeToString, } from "../../../utils/activity.utils";
import { formatAddress } from "../../../utils/address.utils";
import { formatDate } from "../../../utils/date.utils";
import { getLocalizedText } from "../../../utils/i18n/i18n.utils";
import { formatCurrency } from "../../../utils/number.utils";
import * as paymentOrderUtils from "../../../utils/paymentOrder.utils";
import * as paymentRequestUtils from "../../../utils/paymentRequest.utils";
import { capitalize } from "../../../utils/text/text.utils";
import * as S from "./ActivityText.styles";
var ActivityText = /** @class */ (function (_super) {
    __extends(ActivityText, _super);
    // Initialize
    function ActivityText(props) {
        var _this = _super.call(this, props) || this;
        // Render
        _this.render = function () { return _jsx(S.Wrap, { children: _this.renderContent() }); };
        _this.renderContent = function () {
            var activityItem = _this.props.activityItem;
            var actor = activityItem.actor, amount = activityItem.amount, application = activityItem.application, asset = activityItem.asset, broker = activityItem.broker, contact = activityItem.contact, contract = activityItem.contract, contractNewPrice = activityItem.contractNewPrice, contractOldPrice = activityItem.contractOldPrice, contractRentDiscountPrice = activityItem.contractRentDiscountPrice, dateOfCancellation = activityItem.dateOfCancellation, datetime = activityItem.datetime, documentFilename = activityItem.documentFilename, documentPackage = activityItem.documentPackage, email = activityItem.email, employee = activityItem.employee, epcExpirationDate = activityItem.epcExpirationDate, epcLabel = activityItem.epcLabel, epcValue = activityItem.epcValue, invitingAccount = activityItem.invitingAccount, invoiceAmount = activityItem.invoiceAmount, lead = activityItem.lead, linkedPropertyId = activityItem.linkedPropertyId, locationDescriptionRejectionComment = activityItem.locationDescriptionRejectionComment, mainPropertyId = activityItem.mainPropertyId, newStopDate = activityItem.newStopDate, notificationType = activityItem.notificationType, oldStopDate = activityItem.oldStopDate, participant = activityItem.participant, payee = activityItem.payee, payeeBankAccount = activityItem.payeeBankAccount, payer = activityItem.payer, payerBankAccount = activityItem.payerBankAccount, paymentOrder = activityItem.paymentOrder, paymentPayIn = activityItem.paymentPayIn, paymentPayInRemainingBalance = activityItem.paymentPayInRemainingBalance, paymentRequest = activityItem.paymentRequest, paymentTransaction = activityItem.paymentTransaction, property = activityItem.property, propertyInfo = activityItem.propertyInfo, quote = activityItem.quote, reasonForCancellation = activityItem.reasonForCancellation, reference = activityItem.reference, rentAmount = activityItem.rentAmount, rentContractRejectionComment = activityItem.rentContractRejectionComment, roles = activityItem.roles, source = activityItem.source, step = activityItem.step, stopDate = activityItem.stopDate, subtype = activityItem.subtype, tacVersion = activityItem.tacVersion, taskTitle = activityItem.taskTitle, type = activityItem.type, usedSigningType = activityItem.usedSigningType, visitUrl = activityItem.visitUrl;
            var getLinkedProperty = function (contract) {
                var _a;
                if (!linkedPropertyId || !(contract === null || contract === void 0 ? void 0 : contract.linkedProperties)) {
                    return;
                }
                if (((_a = contract.linkedProperties) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var targetProperty = contract.linkedProperties.find(function (item) { return item.linkedPropertyId === linkedPropertyId; });
                    // @ts-ignore
                    return formatAddress(targetProperty === null || targetProperty === void 0 ? void 0 : targetProperty.linkedProperty);
                }
                return;
            };
            var getMainProperty = function (contract) {
                if (!mainPropertyId || !contract || !(contract === null || contract === void 0 ? void 0 : contract.property)) {
                    return;
                }
                return formatAddress(contract.property);
            };
            if (mapActivityTypeToString(type, _this.isInsurance()) === undefined ||
                mapActivitySubtypeToString(subtype, _this.isInsurance()) === undefined) {
                return _this.renderFallbackInfo();
            }
            var paymentType = "invalid payment order";
            if (paymentOrder) {
                paymentType = paymentOrderUtils.getTitle(paymentOrder);
            }
            var paymentRequestPeriod = "invalid payment request";
            if (paymentRequest) {
                if (paymentRequest.startedAt === paymentRequest.endedAt) {
                    paymentRequestPeriod = formatDate(paymentRequest.startedAt);
                }
                else {
                    paymentRequestPeriod = "".concat(formatDate(paymentRequest.startedAt), " - ").concat(formatDate(paymentRequest.endedAt));
                }
            }
            var paymentRequestEstimatedCollectionDate = "invalid payment request";
            if (paymentRequest === null || paymentRequest === void 0 ? void 0 : paymentRequest.estimatedCollectionDate) {
                paymentRequestEstimatedCollectionDate = formatDate(paymentRequest.estimatedCollectionDate);
            }
            var paymentRequestTitle = "invalid payment request";
            if (paymentRequest) {
                paymentRequestTitle = "".concat(paymentRequestUtils.getTitle(paymentRequest), " (").concat(paymentRequestPeriod, ")");
            }
            var actorFormatted = actor
                ? getMappedName(actor, false)
                : getLocalizedText("system.rentio");
            if ((employee === null || employee === void 0 ? void 0 : employee.firstname) || (employee === null || employee === void 0 ? void 0 : employee.lastname)) {
                actorFormatted = "".concat(actorFormatted, " (").concat([
                    employee.firstname,
                    employee.lastname,
                ]
                    .filter(Boolean)
                    .join(" "), ")");
            }
            var values = {
                createdAtDateAndTime: datetime
                    ? formatDate(datetime, "dd/MM/yyyy HH:mm")
                    : "invalid datetime",
                createdAtDate: datetime ? formatDate(datetime) : "invalid datetime",
                createdAtTime: datetime
                    ? formatDate(datetime, "HH:mm")
                    : "invalid datetime",
                actor: actorFormatted,
                amount: amount ? formatCurrency(amount) : "invalid amount",
                application: application
                    ? getName(application.contacts[0])
                    : getLocalizedText("activity.param_not_available.application"),
                applicationEmail: (application === null || application === void 0 ? void 0 : application.applicationEmail) || "No email",
                asset: asset ? asset.name : "invalid asset",
                broker: broker ? broker.name : "invalid broker",
                contact: contact ? getName(contact) : "invalid contact",
                contract: contract
                    ? getLocalizedText("contract.type.".concat(contract.contractType)).toLowerCase()
                    : "invalid contract",
                contractNewPrice: contractNewPrice
                    ? formatCurrency(contractNewPrice)
                    : "invalid amount",
                contractOldPrice: contractOldPrice
                    ? formatCurrency(contractOldPrice)
                    : "invalid amount",
                contractRentDiscountPrice: contractRentDiscountPrice
                    ? formatCurrency(contractRentDiscountPrice)
                    : "invalid amount",
                documentFilename: documentFilename
                    ? documentFilename
                    : "invalid document filename",
                documentPackage: documentPackage
                    ? documentPackage.name
                    : "invalid document package",
                iban: payeeBankAccount ? payeeBankAccount.iban : "invalid iban",
                payeeBankAccount: payeeBankAccount
                    ? payeeBankAccount.iban
                    : "invalid iban",
                payerBankAccount: payerBankAccount
                    ? payerBankAccount.iban
                    : "invalid iban",
                invitingAccount: invitingAccount
                    ? getMappedName(invitingAccount, false)
                    : getLocalizedText("system.rentio"),
                invoiceAmount: invoiceAmount
                    ? formatCurrency(invoiceAmount)
                    : "invalid amount",
                newStopDate: newStopDate
                    ? formatDate(newStopDate)
                    : "invalid new stop date",
                notificationType: notificationType
                    ? getLocalizedText("activity.notification_type.".concat(notificationType)).toLowerCase()
                    : "unknown type: ".concat(notificationType),
                oldStopDate: oldStopDate
                    ? formatDate(oldStopDate)
                    : "invalid old stop date",
                participant: participant
                    ? getMappedName(participant, false)
                    : "invalid participant",
                payee: payee ? getMappedName(payee, false) : "invalid payee",
                payer: payer ? getMappedName(payer, false) : "invalid payer",
                paymentRequestEstimatedCollectionDate: paymentRequestEstimatedCollectionDate,
                paymentRequestAmount: paymentRequest
                    ? formatCurrency(paymentRequest.originalAmount)
                    : "invalid amount",
                paymentRequestPeriod: paymentRequestPeriod,
                paymentRequestInterface: (paymentRequest === null || paymentRequest === void 0 ? void 0 : paymentRequest.paymentInterface)
                    ? getLocalizedText("payment_request.interface.".concat(paymentRequest.paymentInterface))
                    : "invalid payment interface",
                paymentRequestMethod: (paymentRequest === null || paymentRequest === void 0 ? void 0 : paymentRequest.paymentMethod)
                    ? getLocalizedText("payment_request.method.".concat(paymentRequest.paymentMethod))
                    : "invalid payment method",
                paymentTransactionAmount: paymentTransaction
                    ? formatCurrency(paymentTransaction.amount)
                    : "invalid amount",
                paymentRequest: paymentRequestTitle,
                paymentType: paymentType,
                paymentPayInPayerName: (paymentPayIn === null || paymentPayIn === void 0 ? void 0 : paymentPayIn.authorName) || "invalid author",
                paymentPayInPayerIban: (paymentPayIn === null || paymentPayIn === void 0 ? void 0 : paymentPayIn.authorIban) || "invalid author",
                paymentPayInRemainingBalance: paymentPayInRemainingBalance
                    ? formatCurrency(paymentPayInRemainingBalance)
                    : "invalid balance",
                property: property ? formatAddress(property) : "invalid property",
                linkedProperty: getLinkedProperty(contract),
                mainProperty: getMainProperty(contract),
                propertyInfo: propertyInfo
                    ? propertyInfo.reference
                    : "invalid property info",
                roles: roles
                    ? roles
                        .map(function (role) { return getLocalizedText("role.".concat(role.toLowerCase())); })
                        .join(", ")
                    : "invalid roles",
                reference: reference ? reference : "no reference",
                rentAmount: rentAmount ? formatCurrency(rentAmount) : "invalid amount",
                source: source
                    ? getLocalizedText("source.".concat(source.toLowerCase()))
                    : "Rentio",
                step: step
                    ? getLocalizedText("property.dashboard.application.".concat(step, ".title"))
                    : "invalid step",
                tacVersion: tacVersion || "invalid version",
                taskTitle: taskTitle || "invalid task",
                usedSigningType: usedSigningType
                    ? getLocalizedText("used_signing_type.".concat(usedSigningType.toLowerCase()))
                    : "invalid used signing type",
                leadId: lead ? lead.id : "invalid lead",
                leadAddress: lead ? formatAddressLead(lead) : "invalid lead",
                leadName: lead
                    ? "".concat(lead.contactFirstname, " ").concat(lead.contactLastname)
                    : "invalid lead",
                leadReferrer: lead ? lead.referrer : "invalid lead",
                leadEmail: lead ? lead.contactEmail : "invalid email",
                quoteValue: quote
                    ? formatCurrency(quote.calculationValue)
                    : "invalid quote",
                rentContractRejectionComment: rentContractRejectionComment || "invalid reason",
                locationDescriptionRejectionComment: locationDescriptionRejectionComment || "invalid reason",
                epcLabel: epcLabel,
                epcValue: epcValue,
                epcExpirationDate: epcExpirationDate,
                stopDate: stopDate ? formatDate(stopDate) : "invalid stop date",
                reasonForCancellation: reasonForCancellation
                    ? getLocalizedText("contract.cancellation.".concat(reasonForCancellation))
                    : "invalid reason",
                dateOfCancellation: dateOfCancellation
                    ? formatDate(dateOfCancellation)
                    : "invalid cancelled date",
            };
            return _this.renderTouchableActivityText(activityItem, {
                amount: values.amount,
                application: values.application,
                applicationEmail: values.applicationEmail,
                asset: values.asset,
                broker: values.broker,
                contract: values.contract,
                contractNewPrice: values.contractNewPrice,
                contractOldPrice: values.contractOldPrice,
                contractRentDiscountPrice: values.contractRentDiscountPrice,
                createdAtDate: values.createdAtDate,
                createdAtDateAndTime: values.createdAtDateAndTime,
                createdAtTime: values.createdAtTime,
                dateOfCancellation: values.dateOfCancellation,
                email: email,
                epcExpirationDate: values.epcExpirationDate,
                epcLabel: values.epcLabel,
                epcValue: values.epcValue,
                iban: values.iban, // Deprecated => use payerBankAccount / payeeBankAccount
                invitingAccount: values.invitingAccount,
                invoiceAmount: values.invoiceAmount,
                leadAddress: values.leadAddress,
                leadEmail: values.leadEmail,
                leadId: values.leadId,
                leadName: values.leadName,
                leadReferrer: values.leadReferrer,
                locationDescriptionRejectionComment: values.locationDescriptionRejectionComment,
                newStopDate: values.newStopDate,
                notificationType: values.notificationType,
                oldStopDate: values.oldStopDate,
                payeeBankAccount: values.payeeBankAccount,
                payerBankAccount: values.payerBankAccount,
                paymentPayInPayerIban: values.paymentPayInPayerIban,
                paymentPayInPayerName: values.paymentPayInPayerName,
                paymentPayInRemainingBalance: values.paymentPayInRemainingBalance,
                paymentRequestAmount: values.paymentRequestAmount,
                paymentRequestEstimatedCollectionDate: values.paymentRequestEstimatedCollectionDate,
                paymentRequestInterface: values.paymentRequestInterface,
                paymentRequestMethod: values.paymentRequestMethod,
                paymentRequestPeriod: values.paymentRequestPeriod,
                paymentTransactionAmount: values.paymentTransactionAmount,
                propertyInfo: values.propertyInfo,
                quoteValue: values.quoteValue,
                reasonForCancellation: values.reasonForCancellation,
                reference: values.reference,
                rentAmount: values.rentAmount,
                rentContractRejectionComment: values.rentContractRejectionComment,
                roles: values.roles,
                source: values.source,
                step: values.step,
                stopDate: values.stopDate,
                tacVersion: values.tacVersion,
                usedSigningType: values.usedSigningType,
            }, {
                actor: values.actor,
                contact: values.contact,
                documentFilename: documentFilename,
                documentPackage: values.documentPackage,
                linkedProperty: values.linkedProperty,
                mainProperty: values.mainProperty,
                participant: values.participant,
                payee: values.payee,
                payer: values.payer,
                paymentRequest: values.paymentRequest,
                paymentType: values.paymentType,
                property: values.property,
                taskTitle: taskTitle,
                visitUrl: visitUrl,
            });
        };
        _this.renderFallbackInfo = function () { return getLocalizedText("activity.not_supported"); };
        _this.renderTouchableActivityText = function (activityItem, nonTouchableValues, touchableValues) {
            var type = activityItem.type, subtype = activityItem.subtype, lokaliseKey = activityItem.lokaliseKey;
            var key = "activity.".concat(mapActivityTypeToString(type, _this.isInsurance()), ".").concat(mapActivitySubtypeToString(subtype, _this.isInsurance())).toLowerCase();
            // Use custom lokalise key if translated
            if (lokaliseKey && getLocalizedText(lokaliseKey) !== lokaliseKey) {
                key = lokaliseKey;
            }
            var baseString = getLocalizedText(key, nonTouchableValues);
            var stringComponents = baseString.split(/{{|}}/);
            return (_jsx(_Fragment, { children: stringComponents.map(function (stringComponent, index) {
                    var touchableValue = touchableValues[stringComponent];
                    var isVariableInTheKey = baseString.includes("{{".concat(stringComponent, "}}"));
                    if (touchableValue && isVariableInTheKey) {
                        var onParamPress_1 = _this.props.onParamPress;
                        var handlePress = function () {
                            if (onParamPress_1) {
                                onParamPress_1(stringComponent);
                            }
                        };
                        return (_jsx(S.ParamText, { onPress: onParamPress_1 ? handlePress : undefined, children: touchableValue }, index));
                    }
                    if (index === 0) {
                        return capitalize(stringComponent);
                    }
                    return stringComponent;
                }) }));
        };
        // Helpers
        _this.logUnsupportedActivity = function () {
            var _a = _this.props.activityItem, type = _a.type, subtype = _a.subtype;
            if (mapActivityTypeToString(type, _this.isInsurance()) === undefined ||
                mapActivitySubtypeToString(subtype, _this.isInsurance()) === undefined) {
                logger.logError({
                    error: new Error("Unknown activity type or subtype"),
                    parameters: {
                        type: type,
                        subtype: subtype,
                    },
                });
            }
        };
        _this.isInsurance = function () {
            return [EProduct.Insurance, EProduct.InsuranceBackoffice].includes(CONFIG.PRODUCT);
        };
        _this.logUnsupportedActivity();
        return _this;
    }
    return ActivityText;
}(React.PureComponent));
// eslint-disable-next-line import/no-default-export
export default ActivityText;
